import { useDispatch } from "react-redux";
import { closeAddVideoCreativeModal, uploadVideoResource } from "./../../redux/actions/creative-actions";
import { getDayStartTime, getDayEndTime, getLocalDate } from "../../utils/appUtils";
import moment from "moment";

const VideoCreativeForm = (
  form,
  setSelectVideoResourceId,
  setStartDate,
  setEndDate,
  setStartAt,
  setEndAt,
  videoLine,
  accountId,
  setFlightStartDateType,
  setFlightEndDateType,
  selectedDevices,
  setSelectedDevices,
  setCreativeType,
  setSourceCode,
  setSubmitted,
) => {
  const dispatch = useDispatch();
  const dateFormat = "YYYY-MM-DD HH:mm:ss";

  const handleCancel = () => {
    form.resetFields();
    setCreativeType("Video Creative")
    setFlightStartDateType("Start when line starts");
    setFlightEndDateType("End when line ends");
    setStartDate(moment(getDayStartTime(), dateFormat));
    setEndDate(moment(getDayEndTime(), dateFormat));
    setStartAt(getDayStartTime().getTime());
    setEndAt(getDayEndTime().getTime());
    setSelectVideoResourceId("");
    dispatch(closeAddVideoCreativeModal());
  };
  const onStartDateChange = (value, dateString) => {
    setStartDate(value);
    setStartAt(new Date(dateString).getTime());
  };

  const onEndDateChange = (value, dateString) => {
    setEndDate(value);
    setEndAt(new Date(dateString).getTime());
  };

  const onChangeImageSrc = (e, id) => {
    setSelectVideoResourceId(id);
  };

  const handleFileChange = async (e) => {
    let fileObj = e.target.files[0];
    if (fileObj.type.indexOf("video/") === -1) {
      alert("Only Videos are allowed");
      return;
    }
    setSubmitted(true);
    await dispatch(uploadVideoResource(fileObj, accountId));
    setSubmitted(false);    
  };

  const onChangeFlightDateType = (e) => {
    if (e.target.name === "startDate") {
      if(e.target.value === "Custom Start"){
         setFlightStartDateType(e.target.value);
         setStartDate(moment(getDayStartTime(), dateFormat));
         setStartAt(getDayStartTime().getTime());
      }else{
        setFlightStartDateType(e.target.value);
        setStartAt(getLocalDate(videoLine.videoLineVersion.startAt));
      }
    } else {
      if(e.target.value === "Custom End"){
        setFlightEndDateType(e.target.value);
        setEndDate(moment(getDayEndTime(), dateFormat));
        setEndAt(getDayEndTime().getTime());
     }else{
       setFlightEndDateType(e.target.value);
       setEndAt(getLocalDate(videoLine.videoLineVersion.endAt));
     }
    }
  };

  const onDeviceChange = (e) => {
    const devices = selectedDevices;
    if (devices.indexOf(e.target.value) > -1) {
      devices.splice(devices.indexOf(e.target.value), 1);
    } else {
      devices.push(e.target.value);
    }
    setSelectedDevices(devices);
  };

  const onChangeCreativeType = (e) => {
    setCreativeType(e.target.value);
  };

  const onChangeSourceCode = (e) => {
    setSourceCode(e.target.value);
  }

  return [
    handleCancel,
    onStartDateChange,
    onEndDateChange,
    onChangeImageSrc,
    handleFileChange,
    onChangeFlightDateType,
    onDeviceChange,
    onChangeCreativeType,
    onChangeSourceCode
  ];
};

export default VideoCreativeForm;
